import React from 'react'

const InfoCard = ({ data }) => {
  return (
    <div className="bg-secondary flex flex-col gap-1 w-full rounded-lg h-full py-2 px-3">
      <span className="font-light text-[#808080] text-xs">
        {data.title}
      </span>
      <span className="font-semibold text-primary">
        {data.info}{data.value}
      </span>
      <p className="text-xs font-semibold leading-snug min-h-[2.5rem]">
        {data.text}
      </p>
    </div>
  )
}

export default InfoCard